import { connectToModel, bindToPath } from 'client/data/luckdragon/redux/react-binding';
import { VehicleModel, buildVehiclePath } from 'client/data/models/vehicle-v2';

export function overviewItemDataProvider(WrappedComponent) {
  return connectToModel(WrappedComponent, {
    vehicle: bindToPath(props => {
      const { componentParams } = props;

      if (!componentParams?.header) {
        return null;
      }

      const {
        header: { make, model, year },
      } = componentParams;

      return buildVehiclePath({ make: make.value, model: model.value, year });
    }, VehicleModel),
  });
}
